import React from "react";
import styled, { css } from "styled-components";

type ParagraphProps = {
  accent?: boolean;
  inline?: boolean;
  children: React.ReactNode;
};

export const Paragraph = ({ children, accent, inline }: ParagraphProps) => {
  return (
    <StyledParagraph $accent={accent || false} $inline={inline || false}>
      {children}
    </StyledParagraph>
  );
};

const StyledParagraph = styled.p<{ $accent: boolean; $inline: boolean }>`
  font: var(--body-medium-400);
  color: var(--text-gray-8);
  display: inline-block;
  & > b {
    font: var(--body-medium-600);
  }
  ${({ $accent }) =>
    $accent &&
    css`
      width: fit-content;
      padding: 0 0.4rem;
      background-color: var(--sec-orange-0);
      border-radius: 0.4rem;
      color: var(--sec-orange-7);
    `}
  ${({ $inline }) =>
    $inline &&
    css`
      display: inline;
    `}
`;
